import { currentFilterViewKey } from "./types";

export const hasCurrentView = (pageKey: string): boolean => {
    const currentView = localStorage.getItem(currentFilterViewKey) || '{}';
    const parsedCurrentView = JSON.parse(currentView);
    return parsedCurrentView[pageKey] !== undefined;
}